import { keepPreviousData } from '@tanstack/react-query'

/** Overview widgets stay fresh in-session; refresh still revalidates after persist hydrate. */
export const DASHBOARD_STALE_MS = 1000 * 60 * 10
export const DASHBOARD_GC_MS = 1000 * 60 * 60

/** Matches `OVERVIEW_CACHE_TTL_MS` on GET /portal/admin/dashboard/overview. */
export const OVERVIEW_FINANCIAL_STALE_MS = 60_000

export const dashboardQueryOptions = {
  staleTime: DASHBOARD_STALE_MS,
  gcTime: DASHBOARD_GC_MS,
  refetchOnWindowFocus: false as const,
  placeholderData: keepPreviousData,
}

/** Owner money-card rollup: show cached totals for 1m, refetch in the background. */
export const overviewFinancialQueryOptions = {
  ...dashboardQueryOptions,
  staleTime: OVERVIEW_FINANCIAL_STALE_MS,
  refetchInterval: OVERVIEW_FINANCIAL_STALE_MS,
  refetchIntervalInBackground: true,
}
